import { ReactNode } from 'react'

import { OptionProps, SelectProps } from 'antd/lib/select'
import { useField, useFormikContext } from 'formik'

import Icon from 'common/components/general/Icon'

import Tooltip from '../../dataDisplay/Tooltip'
import Label from '../components/Label'
import Option from '../components/Option'
import RedAsterisk from '../components/RedAsterisk'
import Select from '../components/Select'
import FieldProps from './FieldProps'
import Error from './FormItemError'

type DefaultSelectProps = FieldProps & {
  children?: ReactNode
  defaultValue?: string[] | number[]
  disabled?: boolean
  value?: string[] | number[]
  labelStyles?: string
  mode?: 'multiple' | 'tags'
  size?: 'large' | 'small' | 'middle'
  filterOption?: boolean | ((inputValue: string, option: React.ReactElement<OptionProps>) => boolean)
  showSearch?: boolean
  open?: boolean
  items?: SelectOption[]
  onChange?: (value: any) => void
  dropdownRender?: (menu?: React.ReactNode, props?: SelectProps) => React.ReactNode
  onDropdownVisibleChange?: (open: boolean) => void
  showRequiredSign?: boolean
  wrapperClassName?: string
  onClick?: () => void
}

export type SelectOption = {
  id: any
  name: any
}

const FormikSelectField = ({ onChange, ...props }: DefaultSelectProps) => {
  const [field, meta] = useField(props.name)
  const context = useFormikContext()
  const showError = meta.touched && meta.error
  const error = showError ? <Error noPadding>{meta.error}</Error> : null
  const id = props.id || props.name

  const onChangeHandler = (value: any): void => {
    context.setFieldValue(props.name, value)
    if (onChange) {
      onChange(value)
    }
  }

  const handleBlur = () => {
    context.setFieldTouched(props.name)
  }

  return (
    <>
      <div className={`mb-8 select-wrapper ${props.wrapperClassName ?? ''}`}>
        {props.label && (
          <div className="flex align-center">
            {props.label && (
              <Label
                htmlFor={props.id || props.name}
                className={`${props.labelStyles} d-block no-select hand-on-hover`}
              >
                {props.showRequiredSign && <RedAsterisk className={'mr-4'} />}
                {props.label}
              </Label>
            )}
            {props.labelTooltip && (
              <Tooltip title={props.labelTooltip}>
                <Icon type="far fa-question-circle" fontAwesome className="ml-8 color-blue-6" /> {``}
              </Tooltip>
            )}
          </div>
        )}
        {/* @ts-ignore */}
        <Select
          className={`input__no-autofill-color w-100 ${props.className}`}
          id={id}
          onChange={onChangeHandler}
          onBlur={handleBlur as any}
          value={
            field.value !== null && field.value !== undefined
              ? Array.isArray(field.value)
                ? field.value
                : [field.value]
              : undefined
          }
          {...props}
        >
          {props.items &&
            props.items.map((item: SelectOption) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          {!props.items && props.children}
        </Select>
      </div>
      {error}
    </>
  )
}
export { FormikSelectField as Select }
export default FormikSelectField
